import type { PlanStrategyType } from '../types';
import type { PlanStrategy } from './type';

const cache = new Map<PlanStrategyType, PlanStrategy>();
const pending = new Map<PlanStrategyType, Promise<void>>();

const loaders: Record<PlanStrategyType, () => Promise<{ default: PlanStrategy }>> = {
  NAIVE: () => import('./naive'),
  RTB: () => import('./rtb'),
  OOH: () => import('./ooh'),
};

export function getStrategy(key: PlanStrategyType): PlanStrategy {
  const cached = cache.get(key);
  if (!cached) {
    throw new Error(`Strategy "${key}" is not loaded`);
  }
  return cached;
}

export function useStrategy(key: PlanStrategyType): PlanStrategy {
  const cached = cache.get(key);
  if (cached) return cached;

  let promise = pending.get(key);
  if (!promise) {
    promise = loaders[key]().then((mod) => {
      cache.set(key, mod.default);
      pending.delete(key);
    });
    pending.set(key, promise);
  }
  throw promise;
}
